import { cookieDecryption, cookieEncryption, expireTime } from '../../utils';
import { buildSocketOutboundPayload } from '../../utils/socketOutboundPayload';
import socketIo from 'socket.io-client';
import SessionExpiredPopup from '../../components/Popup/SessionExpiredPopup';
import CryptoJS from 'crypto-js';
import _ from 'lodash';
import { hasMessage } from './../model/chatMessages.model';
import { hasChat } from './../model/chats.model';

const getChangedLoader = event => {
  switch (event) {
    default: {
      return 'nothing';
    }
  }
};

const currentUrl = window.location.href;
const url = new URL(currentUrl);
const queryString = url.search;
const params = new URLSearchParams(queryString);

const decryption = data => {
  let bytes = CryptoJS.AES.decrypt(decodeURIComponent(data), process.env.REACT_APP_SECRET_KEY);
  const cryptoBytes = bytes.toString(CryptoJS.enc.Utf8);
  let decryptedData = cryptoBytes ? JSON.parse(cryptoBytes) : null;
  return decryptedData;
};

const paramValue = params.get('query');
const query = decryption(paramValue);

const socketModel = {
  state: {
    socketConnected: false,
    socketLoaders: {
      join: false,
      getNotifications: false,
      chatLoader: false,
    },
  },
  reducers: {
    setConnected(state, payload) {
      state = { ...state, socketConnected: payload };
      return state;
    },
    setSocket(state, payload) {
      state = { ...state, socket: payload };
      return state;
    },
    setLoader(state, payload) {
      state = {
        ...state,
        socketLoaders: {
          ...state.socketLoaders,
          [payload.name]: payload.data,
        },
      };
      return state;
    },
  },

  effects: dispatch => ({
    getSocket({ token, userData }, state) {
      const socketIoClient = socketIo(process.env.REACT_APP_SOCKET_API_KEY, {
        transports: ['websocket', 'polling'],
        upgrade: true,
        reconnection: true,
      });

      socketIoClient.on('connect', () => {
        const payload = {
          event: 'join',
          data: {
            user_id: userData?.userId,
            token: userData?.token,
          },
        };

        dispatch.socketModel.sendEvent({ payload });
      });

      this.setSocket(socketIoClient);
    },

    sendEvent({ payload, changeLoader }, state) {
      const { event, data } = payload;
      const socket = state?.socketModel?.socket;

      if (!changeLoader) {
        this.setLoader({ name: event, data: true });
      } else {
        this.setLoader({ name: changeLoader, data: true });
      }

      if (!socket?.connected) {
        return;
      }

      const outbound = buildSocketOutboundPayload(event, data);
      socket?.emit(event === 'join' ? 'join' : 'request', outbound);
    },

    handleMessageReactionSentEvent(eventPayload, state) {
      const { chatId, lastActivity, lastActivityAt, removedReaction } = eventPayload;

      if (!chatId || !lastActivity || !lastActivity || !lastActivityAt) {
        return;
      }

      const messageExists = hasMessage(state, lastActivity?.reaction?.messageId || lastActivity?.message?.messageId);

      if (messageExists) {
        if (lastActivity?.type === 'reaction') {
          const { messageId, reaction, reactedBy } = lastActivity?.reaction;

          dispatch.chatMessagesModel.addReactionToMessage({
            messageId,
            reaction,
            reactedBy,
            lastActivityAt,
          });
        } else if (removedReaction?.messageId) {
          const messageExists = hasMessage(state, removedReaction.messageId);
          if (messageExists) {
            const { messageId, reaction, reactedBy } = removedReaction;

            dispatch.chatMessagesModel.removeReactionFromMessage({ messageId, reaction, reactedBy });
          }
        }
      }

      const chatExists = hasChat(state, chatId);
      if (chatExists) {
        if (lastActivity?.type === 'reaction') {
          const { messageId, reaction, reactedBy, messageType, contentPreview } = lastActivity?.reaction;
          if (reactedBy === state.authModel.logInUser?.userId) return;

          dispatch.chatsModel.updateReactionLastActivityAndMoveChatToTop({
            chatId,
            messageId,
            reaction,
            reactedBy,
            messageType,
            contentPreview,
            lastActivityAt,
          });
        } else if (lastActivity?.type === 'message') {
          const newLastActivity = {
            type: 'message',
            message: {
              contentPreview: `Reaction removed`,
              messageType: 'Text',
            },
          };
          dispatch.chatsModel.restoreLastActivityAndResort({
            chatId,
            restoredLastActivity: newLastActivity,
          });
        }
      }
    },

    handleChatMessagesMarkedAsReadEvent(response, state) {
      if (response && response.success && response.chatId) {
        const chatId = response.chatId;
        dispatch.chatsModel.updateChatAsRead({ chatId });
      }
    },

    handleMessageStatusUpdate(eventPayload, state) {
      if (eventPayload.updates && eventPayload.updates.length > 0) {
        dispatch.chatMessagesModel.updateMessageStatus(eventPayload);
      }
    },

    handleMessageSentEvent(eventPayload, state) {
      const { chatId, lastActivity, lastActivityAt, messageId } = eventPayload;
      const isOwnMessage = lastActivity?.message?.senderId === state.authModel.logInUser?.userId;

      if (lastActivity?.type === 'message') {
        const selectedChat = state?.chatsModel.selectedChat;
        if (selectedChat?._id === chatId) {
          console.log('ulazi u if', selectedChat);

          (async () => {
            try {
              await dispatch.chatMessagesModel.fetchChatMessageByIdAndAdd({
                chatId,
                messageId,
              });
            } catch (error) {
              console.error(error);
            }
          })();
        }
      }

      const chatExists = hasChat(state, chatId);
      if (chatExists) {
        if (lastActivity?.type === 'message') {
          if (isOwnMessage) {
            dispatch.chatsModel.updateMessageLastActivityAndMoveChatToTop({
              chatId,
              lastActivity,
              lastActivityAt,
            });
          } else {
            dispatch.chatsModel.updateChatLastActivitySilentAndIncrementUnreadMessageCount({
              chatId,
              lastActivity,
              lastActivityAt,
            });
          }
        }
      }
    },

    socketResponse({ response }, state) {
      this.setLoader({ name: response?.event, data: false });
      this.setLoader({ name: getChangedLoader(response?.event), data: false });

      switch (response?.event) {
        case 'join': {
          this.setConnected(true);
          break;
        }
        case 'error': {
          if (state.messagesModel.isErrorOccured) {
            break;
          }
          dispatch.messagesModel.setMsgState({
            name: 'isErrorOccured',
            data: true,
          });
          dispatch.dialogModel.showDialog({
            component: () => <SessionExpiredPopup />,
            className: 'alert_popup_height',
          });
          break;
        }

        case 'partnerShortNameUpdate': {
          const currentUrl = window.location.href;
          if (currentUrl?.includes('messages') && currentUrl?.match(/messages\/([^?]+)/)?.[1]?.length == 24) {
            const groupId = currentUrl?.match(/messages\/([^?]+)/)?.[1];
            const connectionlist = state.messagesModel.connectionList;
            const conversationlistweq = state.messagesModel.messageList;
            const conversationlist = state.messagesModel.messageList?.messageData;

            const index = connectionlist?.findIndex(item => item?.group?._id === groupId);
            const uniqueChats = conversationlist.map(current => {
              if (current.messageType === 'Welcome Message' && current.messageCategory === 'Welcome Prompt') {
                return {
                  ...current,
                  message: current?.content?.replace(':attributes', response?.data?.shortName),
                  groupName: response?.data?.shortName,
                };
              } else {
                return {
                  ...current,
                  groupName: response?.data?.shortName,
                };
              }
            });
            const updatedData = {
              ...conversationlistweq,
              messageData: uniqueChats,
            };

            if (index !== -1) {
              const updatedGroup = {
                ...connectionlist[index].group,
                groupName: response?.data?.shortName,
              };
              connectionlist[index] = {
                ...connectionlist[index],
                group: updatedGroup,
              };
            }

            dispatch.messagesModel.setMsgState({
              name: 'messageList',
              data: updatedData,
            });
            dispatch.messagesModel.setMsgState({
              name: 'connectionList',
              data: connectionlist,
            });
          } else {
            const connectionlist = state.messagesModel.connectionList;
            const index = connectionlist?.findIndex(item => item?.group?._id === response?.data?.groupId);

            if (index !== -1) {
              const updatedGroup = {
                ...connectionlist[index].group,
                groupName: response?.data?.shortName,
              };
              connectionlist[index] = {
                ...connectionlist[index],
                group: updatedGroup,
              };
            }

            dispatch.messagesModel.setMsgState({
              name: 'connectionList',
              data: connectionlist,
            });
          }
          break;
        }
        case 'getNotifications': {
          dispatch.eventModel.setData({ getNotificationList: response?.data });
          break;
        }
        case 'notification': {
          const filteredArray = state?.eventModel?.getNotificationList?.data?.filter(notification => {
            if (
              (notification?.type === 'InvitationDeclined' || notification?.type === 'InvitationApproved') &&
              notification?.dataId === response?.data?.dataId
            ) {
              return (notification.from ?? notification?.from_id) !== response?.data?.from_id;
            }
            return true;
          });
          dispatch.eventModel.setData({
            getNotificationList: {
              ...state?.eventModel?.getNotificationList,
              data: filteredArray && [response?.data, ...filteredArray],
            },
          });
          break;
        }

        case 'getCounts': {
          // Trigger, not value. This count comes from the legacy Notification
          // collection with no category filter, so it includes chat and prompt
          // rows the bell deliberately hides. Refetching the v2 count keeps the
          // badge real-time without letting it disagree with the dropdown.
          void dispatch.notificationsModel.getUnreadCount();
          // Same signal refreshes the list, but only while someone has the tray
          // open. `getCounts` is used rather than the `notification` event above
          // because this is the one the v2 flow is known to emit -- it is what
          // drives the badge today.
          void dispatch.notificationsModel.refreshOpenFeed();
          break;
        }

        case 'readNotification': {
          if (response?.success) {
            const payload = {
              event: 'getNotifications',
              data: { page: 1, limit: 10 },
            };
          }
          break;
        }
        case 'matchedFound': {
          dispatch.homeModel.setData({
            name: 'matchedPopup',
            data: !state.homeModel.matchedPopup,
          });
          dispatch.homeModel.setData({
            name: 'matchedData',
            data: response?.data,
          });
          break;
        }
        case 'readMsg': {
          let updatedData = {
            ...state?.messagesModel?.messageList,
            messageData: state?.messagesModel?.messageList?.messageData?.map(e => {
              if (e.length) {
                return e;
              }
              return { ...e, isRead: true };
            }),
          };
          dispatch.messagesModel.setMsgState({
            name: 'messageList',
            data: updatedData,
          });
          const list = state.messagesModel.connectionList;
          const updatedList = list.map(e => {
            if (e.chatId == response.data.chatId) {
              return {
                ...e,
                lastMessage: {
                  ...e.lastMessage,
                  unreadMessagesCount: 0,
                  isRead: true,
                },
              };
            } else {
              return { ...e };
            }
          });
          dispatch.messagesModel.setMsgState({
            name: 'connectionList',
            data: updatedList,
          });
          break;
        }
        case 'lessonCompleted': {
          if (state.authModel.logInUser.role == 'Mentor') {
          } else if (state.authModel.logInUser.role == 'Mentee') {
          }
          state.preMatchModel.redirectURLWin.close();
          break;
        }

        case 'userInactivated': {
          if (
            (state.authModel.logInUser?.userId, state?.messagesModel?.messageList?.messageData?.[0]?.receiverId?._id)
          ) {
            let temp = state?.messagesModel?.messageList?.messageData;
            temp[0] = {
              ...temp[0],
              receiverId: {
                ...temp[0].receiverId,
                isDel: response?.data?.isDel,
                isDisabled: response?.data?.isDisabled,
              },
            };
            let updatedData = {
              ...state?.messagesModel?.messageList,
              messageData: temp,
            };
            dispatch.messagesModel.setMsgState({
              name: 'messageList',
              data: updatedData,
            });
          }
          break;
        }

        case 'progressPercentage': {
          if (state.contentProgressModel.contentList?.length > 0) {
            dispatch.contentProgressModel.setData({
              contentList: state.contentProgressModel.contentList?.map(e =>
                e?.enrollId === response?.data?.enrollId
                  ? {
                      ...e,
                      percentage_completed: response?.data?.progressInPercentage,
                      completed: response?.data?.progressInPercentage === '1.0' ? true : false,
                    }
                  : { ...e }
              ),
            });
          }
          if (state.authModel.logInUser.role === 'Mentee') {
            dispatch.homeModel.setData({
              name: 'assignProjectList',
              data: state.homeModel.assignProjectList?.map(e =>
                e?.enrollId === response?.data?.enrollId
                  ? {
                      ...e,
                      percentageCompleted: (response?.data?.progressInPercentage * 100).toFixed(2).replace(/\.00$/, ''),
                    }
                  : { ...e }
              ),
            });
          }
          break;
        }
        case 'timezoneUpdate': {
          let auth = cookieDecryption('userDetails');
          auth.timezone = response?.data?.timezone;
          cookieEncryption('userDetails', auth);
          break;
        }

        case 'leave': {
        }

        default:
          break;
      }
    },
  }),
};

export default socketModel;
